jQuery(document).ready(function($){
	var breakpoint, menuBreakpoint, menuCollapsedBreakpoint;
	breakpoint = 720;
	menuCollapsedBreakpoint = breakpoint + 35;
	menuBreakpoint = menuCollapsedBreakpoint + 250;

	$('.menu-item-has-children').on('mouseover', function(){
		var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
		if(!isMobileMenu(width)) {
			addNavHoverClass($(this));
		}
	});
	$('.menu-item-has-children').on('mouseout', function(){
		var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
		if(!isMobileMenu(width)) {
			removeNavHoverClass($(this), true);
		}
	});

	$('.menu-item-has-children > a').on('click', function(){
		if($(this).attr('href') == '#') {
			if($(this).closest('.menu-item-has-children').hasClass('hovered')) {
				removeNavHoverClass($(this), false);
			} else {
				addNavHoverClass($(this));
			}
		}
	});

	$('.menu-item-has-children > a .caret-wrapper').on('click', function(e){
		e.preventDefault();
		if($(this).closest('.menu-item-has-children').hasClass('hovered')) {
			removeNavHoverClass($(this), false);
		} else {
			addNavHoverClass($(this));
		}
	});

	function isMobileMenu(width) {
		var widthToCheck;
		if($('body').hasClass('has-co-member-menu')) {
			widthToCheck = $('body').hasClass('co-member-menu-collapsed') ? menuCollapsedBreakpoint : menuBreakpoint;
		} else {
			widthToCheck = breakpoint;
		}

		return width <= widthToCheck;
	}

	let closeHoverClassTimer;
	function addNavHoverClass(el) {
		let parentItem = el.closest('.menu-item-has-children');
		$('.menu-item-has-children').each(function(){
			if($(this) != parentItem) $(this).removeClass('hovered');
		})
		parentItem.addClass('hovered');
		clearTimeout(closeHoverClassTimer);
	}

	function removeNavHoverClass(el, delay) {
		let parentItem = el.closest('.menu-item-has-children');
		if(delay) {
			closeHoverClassTimer = setTimeout(function(){
				if(parentItem.hasClass('hovered')) parentItem.removeClass('hovered');
			}, 150);
		} else {
			parentItem.removeClass('hovered');
		}
	}

	if($('#brand-top-header').length) {
		$('.brand-top-header .brands-hamburger-menu').on('click', function(){
			$('#brand-top-header').toggleClass('show-brand-menu');
		});

		$('a[href="#brand-top-header"]').on('click', function(){
			$('#brand-top-header').addClass('show-brand-menu');
		});
	}
});